import {Component} from '@angular/core';
import {GLOBALS, GlobalsService} from '@/_services/globals.service';
import {MessageService} from '@/_services/message.service';
import {WhatsNewComponent} from '@/components/whats-new/whats-new.component';
import {ImpressumComponent} from '@/components/impressum/impressum.component';
import {WelcomeComponent} from '@/components/welcome/welcome.component';
import {LanguageService} from '@/_services/language.service';
import {LangData} from '@/_model/lang-data';
import {Utils} from '@/classes/utils';
import {BackendService} from '@/_services/backend.service';
import {CloseButtonData} from '@/controls/close-button/close-button-data';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {CloseButtonComponent} from '@/controls/close-button/close-button.component';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatDivider} from '@angular/material/list';
import {SiteTactaComponent} from '@/components/site-tacta/site-tacta.component';
import {ProgressComponent} from '@/components/progress/progress.component';
import {SettingsComponent} from '@/components/settings/settings.component';
import {BoardMode, GameMode, TactaService} from '@/_services/tacta.service';
import {PasswordChangeComponent} from '@/components/password-change/password-change.component';
import {DsgvoComponent} from '@/components/dsgvo/dsgvo.component';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';
import {FormsModule} from '@angular/forms';
import {TactaCardService} from '@/_services/tacta-card.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [
    MatMenuTrigger,
    CloseButtonComponent,
    MatIcon,
    MatMenu,
    MatIconButton,
    MatMenuItem,
    MatDivider,
    SiteTactaComponent,
    ProgressComponent,
    MatButtonToggleGroup,
    FormsModule,
    MatButtonToggle
  ]
})
export class MainComponent {
  closeData: CloseButtonData = {
    colorKey: 'main',
    showClose: false
  };
  protected readonly Utils = Utils;
  protected readonly BoardMode = BoardMode;
  protected readonly GameMode = GameMode;

  constructor(public globals: GlobalsService,
              public ts: TactaService,
              public msg: MessageService,
              public bs: BackendService,
              public tcs: TactaCardService,
              public ls: LanguageService) {
  }

  get styleForMain() {
    const ret = this.ts.colors.map(c => c.f === '#000000' ? null : c.f);
    return {
      background: `radial-gradient(circle,${ret[1]} 50px,${Utils.join(ret, ',')})`
    }
  }

  clickSave(evt: MouseEvent) {
    evt.stopPropagation();
    GLOBALS.saveSharedData();
  }

  clickDebug(evt: MouseEvent) {
    evt.stopPropagation();
    GLOBALS.isDebug = !GLOBALS.isDebug;
  }

  clickWhatsNew() {
    this.msg.showPopup(WhatsNewComponent, 'whatsnew', null);
  }

  clickImpressum() {
    this.msg.showPopup(ImpressumComponent, 'impressum', null);
  }

  clickWelcome() {
    this.msg.showPopup(WelcomeComponent, 'welcome', null);
  }

  languageClass(item: LangData): string[] {
    const ret = ['themelogo'];
    if (GLOBALS.language != null && item.code === GLOBALS.language.code) {
      ret.push('currLang');
    }
    return ret;
  }

  clickLanguage(item: LangData) {
    GLOBALS.language = item;
    GLOBALS.saveWebData();
    location.reload();
  }

  clickPlay(evt: PointerEvent) {
    evt.stopPropagation();
    this.ts.boardMode.set(BoardMode.Play);
    this.tcs.initGame();
  }

  clickPrepare(evt: PointerEvent) {
    evt.stopPropagation();
    if (this.ts.gameMode() === GameMode.Quick) {
      for (const player of this.ts.players) {
        let quick = player.quick.find(q => q.active);
        if (quick != null) {
          quick.score = player.score;
          quick.active = false;
          quick = player.quick.find(q => !q.active && q.score < 0);
          if (quick != null) {
            quick.active = true;
          }
        }
      }
    }
    this.ts.boardMode.set(BoardMode.Prepare);
  }

  onClick(key: string) {
    switch (key) {
      case 'password':
        this.msg.showPopup(PasswordChangeComponent, 'password', {});
        break;
      case 'whatsnew':
        this.msg.showPopup(WhatsNewComponent, 'whatsnew', {});
        break;
      case 'impressum':
        this.msg.showPopup(ImpressumComponent, 'impressum', {});
        break;
      case 'dsgvo':
        this.msg.showPopup(DsgvoComponent, 'dsgvo', {});
        break;
      case 'welcome':
        this.msg.showPopup(WelcomeComponent, 'welcome', {});
        break;
      case 'settings':
        this.msg.showPopup(SettingsComponent, 'settings', {});
        break;
      case 'logout':
        this.bs.logout(() => {
          GLOBALS.saveSharedData();
          this.msg.showPopup(WelcomeComponent, 'welcome', {});
        });
        break;
    }
  }
}
